import { Grid, Typography, Link, Container } from "@mui/material";
import { Box } from "@mui/system";
import config from "../../../utils/config";
import Cross from "../../../assets/logo/cross.svg";
import AppButton from "../../../components/AppButton";
import { HomeOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function FailedComponent({ withdrawData }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (<Container>

    <Grid container sx={{ color: "#F8FAFF", marginTop: 4 }}>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            flexFlow: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Cross style={{ width: 84, height: 84 }} />
          <Typography
            color={"#F8FAFF"}
            textAlign="center"
            marginTop={3}
            fontWeight={700}
            fontSize={24}
          >
            {t('TransferInitFailed')}
          </Typography>
        </Box>
      </Grid>
      <Grid item>
        <Box
          sx={{
            fontSize: 14,
            fontWeight: 400,
            color: "#D4D4D8",
            lineHeight: "200%",
            marginTop: 5,
          }}
        >
          <Typography>
            {t("ReasonTransferFailed")}:
            <ul>
              <li>{t("WalletIssues")}</li>
              <li>{t("NetworkIssues")}</li>
            </ul>
          </Typography>
        </Box>
        <Box
          sx={{
            fontSize: 14,
            fontWeight: 400,
            color: "#D4D4D8",
            lineHeight: "200%",
            marginTop: 1,
          }}
        >
          <Typography>
          {t("FailedInstruction")}{" "}
            <Link
              href={config.WALLET_GUIDE}
              target={"_blank"}
              color={"#0088F5"}
            >
              {t("here")}
            </Link>
          </Typography>
        </Box>
        <Box
          sx={{
            fontSize: 14,
            fontWeight: 400,
            color: "#D4D4D8",
            lineHeight: "200%",
            marginTop: 1,
          }}
        >
          <Typography>
            {t("ContactTeam")}{" "}
            <Link
              href={config.ZENDESK_SUPPORT}
              target={"_blank"}
              color={"#0088F5"}
            >
                     {t("here")}

            </Link>{" "}
            {t("EmailTo")}
            <Link color={"#0088F5"}>{config.SUPPORT_EMAIL}</Link>
          </Typography>
        </Box>
        <Box
          sx={{
            fontSize: 14,
            fontWeight: 400,
            color: "#D4D4D8",
            lineHeight: "200%",
            marginTop: 1,
          }}
        >
          <Typography>
         {t("ApologyAndAppreciation")}
          </Typography>
        </Box>
      </Grid>
    </Grid>
    <AppButton
      sx={{ marginTop: 10 }}
      startIcon={<HomeOutlined />}
      onClick={() => navigate("/home")}
      title={t("BackDashboard")}
    ></AppButton>
  </Container>
  );
}
